import React, { useState } from 'react';
import styles from './cookies-preferences-modal.module.scss';
import { PageOne } from './modal-screens/page-one';
import { PageTwo } from './modal-screens/page-two';
import { PageThree } from './modal-screens/page-three';
import { CookieUtils, CookieBrowserPreferencesReturn } from './utils';

type Props = {
  payload: {
    initialPage: number;
    languageSelector: any;
    cookieUtils: CookieUtils;
    privacyPolicyUrl: string;
  };
  onClose: (preferences: CookieBrowserPreferencesReturn) => void;
};

export const CookiesPreferencesModal = ({
  payload: { initialPage = 0, languageSelector, cookieUtils, privacyPolicyUrl },
  onClose,
}: Props) => {
  const [page, setPage] = useState(initialPage);
  return (
    <div className={styles.container}>
      {page === 0 && (
        <PageOne
          onClose={onClose}
          nextPage={() => setPage(1)}
          languageSelector={languageSelector}
          cookieUtils={cookieUtils}
          privacyPolicyUrl={privacyPolicyUrl}
        />
      )}
      {page === 1 && (
        <PageTwo
          onClose={onClose}
          changePage={() => setPage(2)}
          cookieUtils={cookieUtils}
        />
      )}
      {page === 2 && (
        <PageThree cookieUtils={cookieUtils} changePage={() => setPage(1)} />
      )}
    </div>
  );
};

CookiesPreferencesModal.displayName = 'CookiesPreferencesModal';
